import style from "./style.scss";
import { mergeClasses } from "../helpers";
import { useState } from "preact/hooks";
import { usePopup } from "../popup/context";
import PopupImage from "../popup/image";

const ImageSet = ({
  images,
  right = false,
  size = 4,
  firstRowSize = 0,
  maxShow = null,
  referrerpolicy = null,
  loading = "lazy",
  border = false,
  shadow = false,
  showAlt = false,
  backgroundColor = null,
}) => {
  const [showAll, setShowAll] = useState(
    !(maxShow != null && maxShow > 0 && maxShow < images.length)
  );

  const popup = usePopup();

  const openSlideshow = (e, index) => {
    e.preventDefault();

    popup.showPopup(
      <PopupImage
        images={images}
        index={index}
        showAlt={showAlt}
        backgroundColor={backgroundColor}
        referrerpolicy={referrerpolicy}
        loading={loading}
        closePopupHandler={popup.hidePopup}
        ariaLabel={images.length > 1 ? "Image Gallery" : "Image Popup"}
      />
    );
  };

  const visibleImages = showAll ? images : images.slice(0, maxShow);

  const renderImageItem = (image, index) => {
    const isShowMore = !showAll && index === maxShow - 1;

    return (
      <li
        key={index}
        class={mergeClasses([
          style.item,
          (border == true && image.border != false) || image.border == true
            ? style.border
            : null,
          shadow == true ? style.shadow : null,
          isShowMore ? style.showMore : null,
        ])}
      >
        <img
          src={image.sm ? image.sm : image.lg}
          alt={image.alt}
          referrerpolicy={referrerpolicy}
          loading={loading === "eager" ? "eager" : "lazy"}
          role="button"
          tabIndex={0}
          onClick={(e) =>
            !showAll && index === maxShow - 1
              ? setShowAll(true)
              : openSlideshow(e, index)
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              isShowMore ? setShowAll(true) : openSlideshow(e, index);
            }
          }}
        />
      </li>
    );
  };

  const firstRow = firstRowSize ? visibleImages.slice(0, firstRowSize) : null;
  const rest = visibleImages.slice(firstRowSize);

  return (
    <div
      class={mergeClasses([
        style.imageSet,
        right && style.imageRight,
        style[`size-${size}`],
        firstRowSize && style[`firstRow-${firstRowSize}`],
      ])}
    >
      <ul class={style.mainGrid}>
        {firstRow && (
          <li
            class={mergeClasses([
              style.item,
              style.firstRow,
              style[`size-${firstRowSize}`],
            ])}
          >
            <ul class={style.subGrid}>
              {firstRow.map((image, index) => renderImageItem(image, index))}
            </ul>
          </li>
        )}

        {rest.map((image, index) => {
          const globalIndex = index + firstRowSize;
          return renderImageItem(image, globalIndex);
        })}
      </ul>
    </div>
  );
};

export default ImageSet;
